import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { SignerDocumentIdPayload } from 'Interfaces/Document';
import { $actions } from 'Store';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: SignerDocumentIdPayload) =>
    $actions.documentSign.sendSignatoryOpened(dispatch, payload),
  );
};
